import { clsx, type ClassValue } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

const twMergePrefixed = extendTailwindMerge({
  prefix: 'fv',
})

// Convenience utility for merging Tailwind classes without conflict, while providing robust class joining.
// https://github.com/lukeed/clsx
// https://github.com/dcastil/tailwind-merge
//
// NOTE: Be intentional with usage. It is not always desired to merge tailwind classes. This is also not a "free" computation.
export function cn(...inputs: ClassValue[]) {
  return twMergePrefixed(clsx(inputs))
}
